import React from 'react';
import ReactDOM from 'react-dom';

import EditorForDataGridMix from './EditorForDataGridMix';
import LookupActions from '../actions/LookupActions';
import RecordsActions from '../actions/RecordsActions';
import {RecordFieldChangeStore} from '../stores/RecordsStore';
import {DsAllowEditStore} from '../stores/CmdTypeStore';
import Warning from '../utils/Warn';
import FormItemLongEditor from './FormItemLongEditor';
import FormItemLongResolver from './resolver/FormItemLongResolver';
import FormItemConst from './FormItemConst';

export default class FormItemLongEditorForDataGrid extends EditorForDataGridMix(FormItemLongEditor)
{

	initStores()
	{
		this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
		this.unsubscribeDsAllowEditStore = DsAllowEditStore.listen(this.onDsAllowEditStore.bind(this));
	}

	componentWillUnmount()
	{
		this.unsubscribeRecordFieldChangeStore();
		this.unsubscribeDsAllowEditStore();
	}

	onDsAllowEditStore(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			let finalValue = this.props.control.getProperty_AllowEdit_Final();

			this.doSetEnable(finalValue);	
		}
		
	}

	getValue() {
	    let updated = {};
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		this.justCommit = true;
	    let text = this.getInputNode().value;
	    var _val = FormItemLongResolver.getResult(text,false,this.props.allowNegative);
		if(_val.indexOf("false:") == 0)
		{
			Warning.show({text:_val.substr(6)});
			_val = this.props.value;
		}
	    updated[this.props.column.key] = _val;
	    
	    if(this.props.value != updated[this.props.column.key])
	    {
	    	RecordsActions.RecordFieldChanged(this.props.rowData,this.props.column.key,this.props.value,updated[this.props.column.key],this);
	    	if(this.props.control)
	    	{
				let result;
				if(this.props.column.isdynamic == true)
				{
					result = this.props.control.doFieldModifiedRemote(this.props.column.dynamicFieldName,_val,this.props.value,null,null,{dynamicColumn:true,dynamicKey:this.props.column.dynamicFieldLabel});
				}
				else
				{
					let _oldValue = this.props.value;
					result = this.props.control.doFieldModifiedRemote(this.props.column.key,_val,_oldValue);
				}
	    		
	    		if(!result && !this.props.control.isDataMethodField)
	    		{
	    			return {};
	    		}
				if(result && !this.props.control.isDataMethodField){
					if(this.props.rowData[this.props.column.key] !=this.props.value && this.props.rowData[this.props.column.key]!=_val){
						_val = this.props.rowData[this.props.column.key];
						updated[this.props.column.key] = _val;
					}
				}
	    	}
	    }
	    return updated;
	}

	componentDidMount()
	{
		if(this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final(this.props.rowData);
			this.doSetEnable(_allowEdit);
		}

		if(this.props.contextMenuData)
			$(this.inputField).contextPopup(this.props.contextMenuData);
		
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			$(this.inputField).css("backgroundColor",FormItemConst.EDITOR_NOTEDIT_COLOR);
			$(this.inputField).attr("readonly","readonly");
		}
		else if(nowAllowEdit == false && enable == true)
		{
			$(this.inputField).css("backgroundColor","#FFFFFF");
			$(this.inputField).removeAttr("readonly");
		}
	}
	
	render()
	{
		let rowStyles = this.getRowStyles();
		let _style = {padding:'2px',width:'100%',backgroundColor:'#ffffff',fontSize:"12px",cursor:'text'};
		let _textAlign = this.props.control.getProperty_Alignment();_style.textAlign = _textAlign.toLowerCase();
		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}

		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}
		if(this.props.height){
			_style.maxHeight=this.props.height-2;
		}

		let _v = this.props.value;
		/*if(this.props.hasInitialValue == true && this.props.control)
		{
			var _allowEdit = this.props.control.getProperty_AllowEdit_Final();

			if(_allowEdit == false)
			{
				if(this.props.column && this.props.column.key)
				{
					let _value = this.props.rowData[this.props.column.key];
					_v = _value;
				}
			}
		}*/

		return(
		    <input spellCheck="false" ref={node => this.inputField = node} id={"input"+this.props.xml.id} type="text"
			       className="form-control" style={_style} onKeyDown={this.onKeyDownHandler.bind(this)}
			       defaultValue={_v}/>
		);
	}
}




// WEBPACK FOOTER //
// ./src/formItem/FormItemLongEditorForDataGrid.js